export const SAVE_USER_INFO = "SAVE_USER_INFO"
export const SAVE_TOKEN_INFO = "SAVE_TOKEN_INFO"
export const SAVE_REFRESH_TOKEN_INFO = "SAVE_REFRESH_TOKEN_INFO"
export const SAVE_USER_ROLE = "SAVE_USER_ROLE"
